import { IAuthUser, IAuthTokens } from '../types';
import AuthConstants, {
    LOGIN,
    LOGOUT,
    SELECT_CUSTOMER,
    BACK_TO_LOGIN,
    REFRESH_ACCESS,
} from '../constants/actions/auth.constants';

export const AuthActions = {
    login: (user: IAuthUser) => ({ type: LOGIN, payload: user }),
    selectCustomer: (
        accessToken: string,
        refreshToken: string,
    ): { type: typeof SELECT_CUSTOMER; payload: IAuthTokens } => ({
        type: SELECT_CUSTOMER,
        payload: { accessToken, refreshToken },
    }),
    refreshUserAccess: () => ({ type: REFRESH_ACCESS }),
    backToLogin: () => ({ type: BACK_TO_LOGIN }),
    logout: () => ({ type: LOGOUT }),
    resetPassword,
    requestResetPassword,
    changePassword,
    loginWithToken,
};

function loginWithToken(token: string, params: string | null) {
    return { type: AuthConstants.LOGIN_WITH_TOKEN, payload: { token, params } };
}

function resetPassword(controlPassword: string, password: string) {
    return {
        type: AuthConstants.RESET_PASSWORD,
        payload: { controlPassword, password },
    };
}

function requestResetPassword(email: string) {
    return { type: AuthConstants.REQUEST_RESET_PASSWORD, payload: email };
}

function changePassword(
    controlPassword: string,
    password: string,
    userId: number,
) {
    return {
        type: AuthConstants.CHANGE_PASSWORD,
        payload: { controlPassword, password, userId },
    };
}
